import React, { useState } from "react";

const Contact = () => {
  const [formulario, setFormulario] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [formData, setFormData] = useState({
    nombre: "",
    email: "",
    mensaje: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (error) setError("");
  };

  const encode = (data) => {
    return Object.keys(data)
      .map(
        (key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key])
      )
      .join("&");
  };

  const handleForm = async (e) => {
    e.preventDefault();

    // Validación básica
    if (
      !formData.nombre.trim() ||
      !formData.email.trim() ||
      !formData.mensaje.trim()
    ) {
      setError("Por favor, completa todos los campos");
      return;
    }

    // Validación de email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      setError("Por favor, ingresa un email válido");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const response = await fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: encode({
          "form-name": "contact",
          ...formData,
        }),
      });

      if (response.ok) {
        setFormulario(false);
        setFormData({ nombre: "", email: "", mensaje: "" });
      } else {
        throw new Error("Error al enviar el formulario");
      }
    } catch (err) {
      console.error("Error:", err);
      setError(
        "Hubo un error al enviar el mensaje. Por favor, intenta de nuevo."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="Contact" id="contact">
      <h2 className="Contact-titulo">Contactame</h2>
      <div className="Contact-container">
        <div className="Contact-text">
          <p>
            Si te intereso mi trabajo y requieres más informacion puedes llenar
            este formulario, con mucho gusto me pondre en contacto =){" "}
          </p>
        </div>
        <div className="Contact-Form">
          {formulario ? (
            <form
              name="contact"
              method="POST"
              data-netlify="true"
              onSubmit={handleForm}
            >
              {/* Campo oculto para el bot de Netlify */}
              <input type="hidden" name="form-name" value="contact" />

              <div className="Contact-inputs">
                <input
                  type="text"
                  name="nombre"
                  placeholder="Nombre"
                  className="Contact-input"
                  value={formData.nombre}
                  onChange={handleChange}
                  required
                />
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  className="Contact-input"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <textarea
                name="mensaje"
                className="Contact-textArea"
                placeholder="Escriba su comentario..."
                value={formData.mensaje}
                onChange={handleChange}
                required
              ></textarea>
              {error && (
                <p
                  className="Contact-error"
                  style={{ color: "red", marginTop: "10px" }}
                >
                  {error}
                </p>
              )}
              <input
                type="submit"
                className="Contact-btn"
                value={loading ? "Enviando..." : "Enviar"}
                disabled={loading}
              />
            </form>
          ) : (
            <div>
              <p className="Contact-p">Mensaje enviado</p>
              <button
                onClick={() => setFormulario(true)}
                className="Contact-btn"
                style={{ marginTop: "10px" }}
              >
                Enviar otro mensaje
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default Contact;
